import { Component, OnInit } from '@angular/core';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'app-top-left-nav-menu',
  templateUrl: './top-left-nav-menu.component.html',
  styleUrls: ['./top-left-nav-menu.component.scss']
})
export class TopLeftNavMenuComponent implements OnInit {

  commonContent;
  constructor(private session: StorageService) {
    this.commonContent = this.session.resource?.commonContent;
   }

  ngOnInit(): void {
    
  }

}